import React, { Component } from "react";
import { Wrapper, Form } from "app/NativeComponents/common";

import SignupCopy from "./SignupCopy";
import Buttons from "./Buttons";
import Inputs from "./Inputs";

class PartnerSignup extends Component {
  constructor(props) {
    super(props);
    var partner_info;
    if (props.partner_info) {
      partner_info = {
        company_name: props.partner_info.title,
        company_website: props.partner_info.website,
        paypal_email: props.partner_info.paypal_email,
        accepted_terms: 0
      };
    } else {
      partner_info = {
        company_name: props.user.company,
        company_website: "",
        paypal_email: "",
        accepted_terms: 0
      };
    }

    this.state = {
      orginalPartnerInfo: partner_info,
      editPartnerInfo: partner_info
    };
  }

  updatePartnerInfo({ value, prop }) {
    this.setState({
      editPartnerInfo: {
        ...this.state.editPartnerInfo,
        [prop]: value
      }
    });
  }

  savePartnerInfo() {
    this.props.savePartnerInfo({
      token: this.props.token,
      type: "signup",
      payload: {
        company_name: this.state.editPartnerInfo.company_name,
        company_website: this.state.editPartnerInfo.company_website,
        paypal_email: this.state.editPartnerInfo.paypal_email,
        accepted_terms:
          this.props.accepted_affiliate_latest_terms == 1
            ? 1
            : this.state.editPartnerInfo.accepted_terms
      }
    });
  }

  render() {
    return (
      <Wrapper>
        <SignupCopy {...this.props} />
        <Form onSubmit={() => this.savePartnerInfo()}>
          <Inputs
            {...this.props}
            editPartnerInfo={this.state.editPartnerInfo}
            updatePartnerInfo={this.updatePartnerInfo.bind(this)}
          />
          <Buttons
            {...this.props}
            updatePartnerInfo={this.updatePartnerInfo.bind(this)}
            originalPartnerInfo={this.state.originalPartnerInfo}
            editPartnerInfo={this.state.editPartnerInfo}
            savePartnerInfo={this.savePartnerInfo.bind(this)}
          />
        </Form>
      </Wrapper>
    );
  }
}

export default PartnerSignup;
